import initListExpanders from '../list-expander';
import LocationMap from '../locationsmap';
import Logger from '../logging/logger';

function onPopupOpenLocation( event: CustomEvent ): void {
    const detail = event.detail || {};

    Logger.info( 'Event Triggered: onPopupOpenLocation', detail );

    const container: HTMLElement | Document = detail.container || document;

    const mapContainer = document.querySelector<HTMLElement>( '.locationmap__container' );
    if ( mapContainer ) {
        new LocationMap( mapContainer );
    }

    initListExpanders( container );
}

export default onPopupOpenLocation;
